import React, { Children, ReactElement } from 'react'

import { IChildrenBaseProps } from './types'

interface IChildrenProps extends IChildrenBaseProps {
  [props: string]: any
}

interface IProps {
  children: ReactElement<IChildrenProps>[]
  isHidden?: boolean
}

const Container = ({ isHidden, children }: IProps) => {
  if (isHidden) {
    return <></>
  }

  const childrenList = Children.toArray(children).filter((child: any) => !child.props.isHidden)
  const childrenCount = childrenList.length

  const getClassName = (childrenLength: number) => {
    if (childrenLength > 2) {
      return 'cs-sm-12of12'
    }
    if (childrenLength > 1) {
      return 'cs-md-6of12 cs-sm-12of12'
    }
    return 'cs-sm-12of12'
  }

  return (
    <div className='csas-calc-loan-way-out'>
      <div className='csas-cta-section csas-center'>
        <div className={childrenCount > 2 ? 'cs-sm-12of12' : 'cs-sm-8of12'} data-testid='fu-container'>
          <div className='csas-flex-sm'>
            {childrenList.map((child, index) => (
              <div key={index} className={getClassName(childrenCount)} data-testid='fu-child'>
                {child}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export { Container, IProps }
